import { _ as _export } from '../internals/export.js';
import { o as objectAssign } from '../internals/object-assign.js';

var $ = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});
//# sourceMappingURL=es.object.assign.js.map
